import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrentinpune() {



const cardData = {
  keyword: "Kia Carens On Rent in Pune ",

"headingDescription": "SRS Cab Service offers Kia Carens On Rent in Pune, providing a spacious, comfortable, and reliable travel solution for families, groups, and corporate travelers. Our well-maintained Kia Carens vehicles, professional drivers, and punctual service ensure a smooth and hassle-free journey across Pune and nearby destinations. Ideal for city tours, airport transfers, weekend trips, and business travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and enjoyable travel experience.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and a major landmark in Pune. Travelers renting a Kia Carens from SRS Cab Service often explore this site to admire Maratha architecture and learn about Pune’s cultural heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an important historical monument linked to India’s freedom movement. Visitors using Kia Carens on Rent from SRS Cab Service often visit its serene gardens and informative museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is renowned for its scenic views and trekking opportunities. Travelers renting a Kia Carens from SRS Cab Service often include this destination for sightseeing and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered religious sites. Visitors using Kia Carens on Rent from SRS Cab Service often stop here to experience spiritual serenity and local traditions."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine dedicated to Lord Shiva. Travelers renting a Kia Carens from SRS Cab Service enjoy its historic charm and peaceful environment."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases a vast collection of Indian artifacts. Visitors using Kia Carens on Rent from SRS Cab Service explore Pune’s cultural and artistic heritage here."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune along with historic temples. Travelers renting a Kia Carens from SRS Cab Service often climb the hill for sightseeing and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a serene destination surrounded by water and hills. Visitors using Kia Carens on Rent from SRS Cab Service often include this spot in their itinerary for relaxation and photography."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a Japanese-style landscaped park ideal for calm walks. Travelers renting a Kia Carens from SRS Cab Service enjoy its lush greenery and peaceful ambiance."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace associated with Chhatrapati Shivaji Maharaj. Visitors using Kia Carens on Rent from SRS Cab Service often explore this landmark to understand Pune’s rich history."
  }
],



services: [
{
name: "Kia Carens on Rent in Pune Near Me",
description: "Kia Carens on rent in Pune near me offers quick and nearby booking options. Customers can find 7 seater cars for instant travel needs. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book Kia Carens easily near your location."
},
{
name: "Kia Carens on Rent in Pune Near Me Contact Number",
description: "Kia Carens on rent in Pune near me contact number provides direct booking support. Customers can call and reserve vehicles easily. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Contact Kia Carens rental services quickly."
},
{
name: "Kia Carens for Rent in Pune",
description: "Kia Carens for rent in Pune offers comfortable 7 seater travel for families. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens rentals."
},
{
name: "Pune to Shirdi Kia Carens on Rent",
description: "Pune to Shirdi Kia Carens on rent provides convenient travel for temple visits. Customers can book vehicles for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Shirdi with Kia Carens."
},
{
name: "Kia Carens for Rent for Corporate",
description: "Kia Carens for rent for corporate offers reliable travel for business needs. Companies can book vehicles for meetings and employee transport. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with corporate Kia Carens services."
},
{
name: "Kia Carens Hire for Outstation",
description: "Kia Carens hire for outstation provides comfortable travel for long-distance trips. Customers can book vehicles for tours and family travel. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens outstation services."
},
{
name: "Pune to Nashik Kia Carens on Rent",
description: "Pune to Nashik Kia Carens on rent offers comfortable travel for religious and leisure trips. Customers can book vehicles for group travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Nashik with Kia Carens."
},
{
name: "Pune to Goa Kia Carens on Rent",
description: "Pune to Goa Kia Carens on rent offers long-distance travel for vacations. Customers can enjoy spacious seating for beach trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Goa with Kia Carens."
},
{
name: "Pune to Mumbai Kia Carens on Rent",
description: "Pune to Mumbai Kia Carens on rent provides reliable intercity travel. Customers can book vehicles for business and leisure trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily from Pune to Mumbai."
},
{
name: "Pune to Ashtavinayak Darshan Kia Carens on Rent",
description: "Pune to Ashtavinayak darshan Kia Carens on rent offers spiritual travel for temple tours. Customers can visit multiple temples comfortably. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens services."
},
{
name: "Pune to Jyotirlinga Darshan Kia Carens on Rent",
description: "Pune to Jyotirlinga darshan Kia Carens on rent provides convenient travel for pilgrimage trips. Customers can visit sacred temples comfortably. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens services."
},
{
name: "Kia Carens Cabs on Rent in Pune",
description: "Kia Carens cabs on rent in Pune offer flexible travel solutions for all needs. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens cabs."
},
{
name: "Luxury Cars Kia Carens Rental Services",
description: "Luxury cars Kia Carens rental services offer premium travel experience for customers. Users can enjoy high-end features and comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel comfortably with Kia Carens luxury services."
},
{
name: "Luxury Car Monthly Rental",
description: "Luxury car monthly rental offers long-term travel solutions with premium vehicles. Customers can lease cars for business or personal use. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible plans are available. Travel easily with monthly luxury car rentals."
},
{
name: "Kia Carens on Rent in Pune",
description: "Kia Carens on rent in Pune provides reliable transportation for families and groups. Customers can book vehicles for city and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens rentals."
},
{
name: "Kia Carens on Rent for Outstation",
description: "Kia Carens on rent for outstation offers comfortable travel for long-distance trips. Customers can book vehicles for tours and vacations. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens services."
},
{
name: "7 Seater Car on Rent in Pune",
description: "7 seater car on rent in Pune provides convenient travel for families and small groups. Customers can book vehicles for trips and outings. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 7 seater cars."
},
{
name: "7 Seater Kia Carens on Rent in Pimpri Chinchwad",
description: "7 seater Kia Carens on rent in Pimpri Chinchwad offers local and outstation travel solutions. Customers can book vehicles for family trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens services."
},
{
name: "Kia Carens on Rent in Pimpri Chinchwad",
description: "Kia Carens on rent in Pimpri Chinchwad provides convenient travel options for customers. Users can book vehicles for flexible trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens rentals."
},
{
name: "Kia Carens Rent Pune",
description: "Kia Carens rent Pune offers flexible vehicle options for all travel needs. Customers can rent cars for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Rent Kia Carens easily in Pune."
},
{
name: "Kia Carens Hire Pune",
description: "Kia Carens hire Pune provides reliable transportation for daily and long-distance travel. Customers can hire vehicles for flexible trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Hire Kia Carens easily in Pune."
},
{
name: "Kia Carens Rental Pune",
description: "Kia Carens rental Pune offers convenient travel solutions for families and groups. Customers can book vehicles for tours and events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens rentals."
},
{
name: "Kia Carens Cab Service Pune",
description: "Kia Carens cab service Pune provides dependable transportation for city and outstation travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens cab services."
},
{
name: "Kia Carens Taxi Pune",
description: "Kia Carens taxi Pune offers reliable transportation for all travel needs. Customers can book taxis for city and intercity trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens taxis."
},
{
name: "Kia Carens Cab Pune",
description: "Kia Carens cab Pune provides convenient travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Kia Carens cabs."
},
{
name: "Kia Carens Booking Pune",
description: "Kia Carens booking Pune offers quick and easy reservation options. Customers can book vehicles online or via phone. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book your Kia Carens easily in Pune."
},
{
name: "Kia Carens Cab Booking Pune",
description: "Kia Carens cab booking Pune provides convenient booking options for travelers. Customers can reserve cabs instantly online. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book your Kia Carens cab easily."
},
{
name: "Kia Carens Price per km Pune",
description: "Kia Carens price per km Pune provides clear pricing details for travel planning. Customers can check per km rates before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Choose Kia Carens services with transparent pricing."
}
],

tableData: [
["Kia Carens on Rent in Pune Near Me","Kia Carens on Rent in Pune Near Me Contact Number"],
["Kia Carens for Rent in Pune","Pune to Shirdi Kia Carens on Rent"],
["Kia Carens for Rent for Corporate","Kia Carens Hire for Outstation"],
["Pune to Nashik Kia Carens on Rent","Pune to Goa Kia Carens on Rent"],
["Pune to Mumbai Kia Carens on Rent","Pune to Ashtavinayak Darshan Kia Carens on Rent"],
["Pune to Jyotirlinga Darshan Kia Carens on Rent","Kia Carens Cabs on Rent in Pune"],
["Luxury Cars Kia Carens Rental Services","Luxury Car Monthly Rental"],
["Kia Carens on Rent in Pune","Kia Carens on Rent for Outstation"],
["7 Seater Car on Rent in Pune","7 Seater Kia Carens on Rent in Pimpri Chinchwad"],
["Kia Carens on Rent in Pimpri Chinchwad","Kia Carens Rent Pune"],
["Kia Carens Hire Pune","Kia Carens Rental Pune"],
["Kia Carens Cab Service Pune","Kia Carens Taxi Pune"],
["Kia Carens Cab Pune","Kia Carens Booking Pune"],
["Kia Carens Cab Booking Pune","Kia Carens Price per km Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Premium MPV for Family & Group Travel",
    WhyChoosedescription: "SRS Cab Service offers Kia Carens on rent in Pune, a stylish and spacious MPV perfect for family trips, corporate travel, and airport transfers with superior comfort."
  },
  {
    WhyChooseheading: "Affordable Kia Carens Rental Pricing",
    WhyChoosedescription: "We provide budget-friendly Kia Carens rental in Pune with transparent pricing. Rates typically start from around ₹18 per km for outstation travel depending on trip type. :contentReference[oaicite:0]{index=0}"
  },
  {
    WhyChooseheading: "Ideal for Outstation & Airport Travel",
    WhyChoosedescription: "Kia Carens is ideal for Pune to Mumbai, Shirdi, Nashik, Goa, and airport transfers, offering smooth performance, comfort, and excellent space for long journeys."
  },
  {
    WhyChooseheading: "24/7 Kia Carens Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Kia Carens bookings in Pune, making it convenient for early morning flights, late-night travel, and emergency bookings."
  },
  {
    WhyChooseheading: "Spacious 6+1 & 7 Seater Options",
    WhyChoosedescription: "Kia Carens comes with spacious seating configurations, making it ideal for families, corporate groups, and small teams with ample luggage space."
  },
  {
    WhyChooseheading: "Luxury Interiors & Comfortable Ride",
    WhyChoosedescription: "The vehicle features premium interiors, AC, pushback seating, and smooth suspension, ensuring a relaxed and enjoyable travel experience. :contentReference[oaicite:1]{index=1}"
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "We provide trained and experienced drivers familiar with Pune routes and highways, ensuring safe, smooth, and stress-free journeys."
  },
  {
    WhyChooseheading: "Trusted Kia Carens Rental in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for Kia Carens on rent in Pune due to reliable service, clean vehicles, and excellent customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide Kia Carens on rent in Pune?", answer: "Yes, SRS Cab Service offers Kia Carens rental in Pune for local, airport, and outstation travel." },
  { question: "What is the price of Kia Carens per km in Pune?", answer: "Kia Carens rental typically starts from around ₹18 per km depending on trip type and duration." },
  { question: "Is Kia Carens suitable for outstation trips?", answer: "Yes, Kia Carens is ideal for long-distance travel like Mumbai, Goa, Shirdi, Nashik, and more." },
  { question: "How many passengers can travel in Kia Carens?", answer: "Kia Carens offers 6+1 and 7 seater configurations suitable for families and small groups." },
  { question: "Is Kia Carens available for airport transfer?", answer: "Yes, Kia Carens is perfect for Pune Airport and Mumbai Airport transfers." },
  { question: "Is Kia Carens cab available 24/7?", answer: "Yes, our service operates 24 hours a day for flexible booking." },
  { question: "Are Kia Carens cars air-conditioned?", answer: "Yes, all Kia Carens vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book Kia Carens online?", answer: "Yes, you can easily book Kia Carens on rent in Pune online or via phone." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip Kia Carens cab services." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Kulkarni",
    feedback:
      "Booked Kia Carens from SRS Cab Service for Goa trip. Very spacious and comfortable for our family.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Patil",
    feedback:
      "Best Kia Carens rental in Pune. Clean car, smooth ride, and professional driver.",
    rating: 5
  }
];































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens On Rent in Pune | SRS Cab",
  "description": "SRS Cab offers Kia Carens on rent in Pune for local travel, airport transfers, corporate use, and outstation trips. Hire 7-seater Kia Carens for Pune to Shirdi, Nashik, Goa, Mumbai, Ashtavinayak, and Jyotirlinga tours. Enjoy luxury, comfort, and affordable fares with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};









  return (
    <div>
      <Helmet>
  <title>Kia Carens On Rent in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Hire Kia Carens on rent in Pune with SRS Cab. 7-seater luxury car for local travel, airport transfers, corporate use, and outstation trips to Shirdi, Nashik, Goa, Mumbai and more. Book online with 24x7 service and affordable fares." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarenceonrentinpune;